const { feWp } = window;

/**
 * Initializes the infinity carousel with custom settings.
 *
 * @function setupInfinityCarousel
 */
const setupInfinityCarousel = () => {
  const carouselWrapper = '.e-lgs';
  const carouselItem = 'li';
  const carouselTrackWrapper = '.e-lgs__list';
  const defaultStartCarouselItemCount = 4;
  const defaultAnimateDirection = 'left';
  const defaultAnimateSpeed = 30;
  const trackStartAnimateClass = 'start-marquee';
  const carouselWrapperActiveClass = 'loaded';

  const infinityCarousels = document.querySelectorAll(carouselWrapper);

  if (infinityCarousels.length <= 0) return;

  infinityCarousels.forEach((infinityCarousel) => {
    const isDisableOnMobile = infinityCarousel.dataset.disableOnMobile;
    const screenWidth = window.screen.width;

    if (isDisableOnMobile === 'true' && screenWidth <= 768) return;

    const carouselItems = infinityCarousel.querySelectorAll(carouselItem);
    const carouselTrack = infinityCarousel.querySelector(carouselTrackWrapper);

    const startAnimateCount =
      carouselTrack.getAttribute('logo-count-enable-slider') ||
      defaultStartCarouselItemCount;

    if (carouselItems.length < startAnimateCount) {
      return false;
    }

    const animationDuration = carouselTrack.getAttribute('animation-duration');
    const animationSpeed = getAnimationSpeed(
      animationDuration,
      defaultAnimateSpeed,
    );
    const animateDirection =
      infinityCarousel.getAttribute('data-direction') ||
      defaultAnimateDirection;

    carouselTrack.classList.add(trackStartAnimateClass);
    carouselTrack.classList.add(animateDirection);

    infinityCarousel.classList.add(carouselWrapperActiveClass);

    carouselTrack.style.animationDuration = `${animationSpeed}s`;
    carouselTrack.style.setProperty(
      '--translateX',
      `-${calculateTotalWidth(carouselTrack, carouselItem)}px`,
    );

    carouselTrackFill(carouselTrack, carouselItem);

    carouselTrack.style.width = `${calculateTotalWidth(
      carouselTrack,
      carouselItem,
    )}px`;
  });
};
/**
 * Fills the carousel track with cloned items until the total width exceeds the screen width.
 *
 * @param {HTMLElement} carouselTrack - The carousel track element.
 * @param {string}      carouselItem  - Selector for carousel items.
 */
const carouselTrackFill = (carouselTrack, carouselItem) => {
  const screenWidth = window.screen.width;
  let totalWidth = calculateTotalWidth(carouselTrack, carouselItem);

  cloneCarouselItems(carouselTrack, carouselItem);

  while (totalWidth < screenWidth) {
    cloneCarouselItems(carouselTrack, carouselItem);
    totalWidth = calculateTotalWidth(carouselTrack, carouselItem);
  }
};

/**
 * Gets the animation speed value, falling back to a default value if necessary.
 *
 * @param {number} speedValue   - The animation speed value (optional).
 * @param {number} defaultValue - The default animation speed.
 * @return {number} - The animation speed.
 */
const getAnimationSpeed = (speedValue, defaultValue) => {
  if (speedValue === undefined || isNaN(speedValue)) {
    return defaultValue;
  }
  return Number(speedValue);
};

/**
 * Clones carousel items and appends them to the carousel track.
 *
 * @param {HTMLElement} carouselTrack - The carousel track element.
 * @param {string}      carouselItem  - Selector for carousel items.
 */
const cloneCarouselItems = (carouselTrack, carouselItem) => {
  const carouselItems = carouselTrack.querySelectorAll(carouselItem);
  carouselItems.forEach((carouselItem) => {
    const clone = carouselItem.cloneNode(true);
    carouselTrack.appendChild(clone);
  });
};

/**
 * Calculates the total width of all carousel items.
 *
 * @param {HTMLElement} carouselTrack - The carousel track element.
 * @param {string}      carouselItem  - Selector for carousel items.
 * @return {number} - The total width of carousel items.
 */
const calculateTotalWidth = (carouselTrack, carouselItem) => {
  const carouselItems = carouselTrack.querySelectorAll(carouselItem);
  let totalWidth = 0;

  carouselItems.forEach((item) => {
    totalWidth += item.offsetWidth;
  });
  return totalWidth;
};

const initLogoSliderScript = () => {
  const { addAction } = feWp.hooks;

  addAction(
    'b3rg_logo_slider_init',
    'b3rg/logo-slider',
    setupInfinityCarousel,
    10,
    1,
  );

  window.addEventListener('load', () => {
    setupInfinityCarousel();
  });
};

const waitForFeWpHooks = () => {
  if (feWp && feWp.hooks) {
    initLogoSliderScript();
  } else {
    setTimeout(waitForFeWpHooks, 50);
  }
};

waitForFeWpHooks();
